module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA21.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA21.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA21.w.3.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA21.w.4.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA21.w.5.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA21.w.6.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA21"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.22.0.0.box.820.353.866.68.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA21.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_heading",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "para.22.0.0.box.820.353.866.68.q.80"
    }
  }, [_vm._v("Gov. John W. Ellis")])]), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.22.1.0.box.441.563.1623.1077.q.101"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA21.w.6.1.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0015.jpg"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA21.w.6.1.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.22.2.0.box.304.1662.1893.1232.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA21.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.22.2.0.box.304.1662.1893.548.q.70"
    }
  }, [_vm._v("John Ellis was born in Rowan County and was a graduate of the University of North Carolina. He was governor of North Carolina from 1859 to 1861. During his term of office, while other Southern states were leaving the Union, he led the state of North Carolina in an attempt to remain neutral. However, when U.S. president Abraham Lincoln demanded 75,000 troops to \"put down the rebellion,\" Governor Ellis bristled. He wrote his famous reply in defense of North Carolina's sovereignty, stating, \"You can get no troops from North Carolina.\" He called for a special session of the state legislature, and on May 20, 1860, North Carolina tied her future to the newly formed Confederacy.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA21.w.2.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.22.2.1.box.306.2224.1885.111.q.60"
    }
  }, [_vm._v("Governor Ellis died shortly afterward on July 7, 1861. He is buried in the Old English Cemetery in Salisbury.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA21.w.2.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.22.2.2.box.306.2349.1885.421.q.40"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA21.w.6.2.0"
    }
  }), _vm._v("This flag was made by the ladies of St. Mary's School, in Raleigh, and presented to the governor before his death. It is 42\" (hoist) x 63\" (fly). The red field is 23\" wide, while the royal blue and white bars are 21\" wide. Red twill tape, "), _c('span', {
    staticStyle: {
      "vertical-align": "middle"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA21.w.7.0.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "'A\"",
      "src": "data/content-0016.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA21.w.7.0.0.1"
    }
  })]), _vm._v("wide, is wrapped as reinforcement to three edges. The white satin star is "), _c('span', {
    staticStyle: {
      "vertical-align": "middle"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA21.w.7.0.0.2"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "l0'A\"",
      "src": "data/content-0017.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA21.w.7.0.0.3"
    }
  })]), _vm._v("in diameter. The letters and numerals are of white satin and sewn to the red field. The uppercase letters are "), _c('span', {
    staticStyle: {
      "vertical-align": "middle"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA21.w.7.0.0.4"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "3'A\"",
      "src": "data/content-0018.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA21.w.7.0.0.5"
    }
  })]), _vm._v("high, the numerals are 3\" high, and the superscripts are "), _c('span', {
    staticStyle: {
      "vertical-align": "middle"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA21.w.7.0.0.6"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "V/»\"",
      "src": "data/content-0019.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA21.w.7.0.0.7"
    }
  })]), _vm._v("high.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA21.w.2.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.22.2.3.box.381.2847.1042.47.q.70"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Museum ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("of ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Confederacy, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Richmond, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Va. ")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA22"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA22.w.0.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA22.w.0.0.0.1"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9ad36f24","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/content-0020.vue
// module id = 63
// module chunks = 0